import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LandlordSidebar from '../components/LandlordDashboard/LandlordSidebar';
import LandlordActivityFeed from '../components/LandlordDashboard/LandlordActivityFeed';
import DashboardContent from '../components/LandlordDashboard/DashboardContent';
import LandlordProperties from '../components/LandlordDashboard/LandlordProperties';
import LandlordApplications from '../components/LandlordDashboard/LandlordApplication';
import RoleToggleFeedback from '../components/common/RoleToggleFeedback';
import styles from '../styles/Landlord/LandlordDashboardPage.module.css';

const LandlordDashboardPage = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('dashboard');
  const [role, setRole] = useState('Landlord');
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname.includes('properties')) {
      setActiveTab('properties');
    } else if (location.pathname.includes('applications')) {
      setActiveTab('applications');
    } else {
      setActiveTab('dashboard');
    }
  }, [location.pathname]);

  const handleFeedback = () => {
    window.open('mailto:ACodding@mba2025.hbs.edu?subject=Bug Report / Feedback', '_blank');
  };
  
  const handleRoleChange = (newRole) => {
    setRole(newRole);
    if (newRole === 'Tenant') navigate('/profile');
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'properties':
        return <LandlordProperties />;
      case 'applications':
        return <LandlordApplications />;
      case 'dashboard':
      default:
        return <DashboardContent />;
    }
  };

  return (
    <div className={styles.landlordDashboard}>
      <LandlordSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className={styles.mainContent}>
        <RoleToggleFeedback 
          role={role} 
          onRoleChange={handleRoleChange}
          onFeedback={handleFeedback}
        />
        {renderContent()}
      </div>
      <LandlordActivityFeed />
    </div>
  );
};

export default LandlordDashboardPage;
